// import * as smoothscroll from 'smoothscroll-polyfill'
import './scrolled'
import './menu'
import './cursor'

import './blocks/image'
import './blocks/productlist'
import product from './blocks/product'
import './blocks/testimonials'

product.init()



const base = document.querySelector( 'base' ).href
document.addEventListener( 'click', e => {

    // build link for private docs (prevent bug in gutenberg on save)
    if( e.target.matches( 'a[data-private]' ) ) {
      e.preventDefault()
      const url = base + 'download/file/' + e.target.dataset.private
      window.open( url, '_blank' )
    }

} )

// redirect wpcf7 contact form to "merci" page
const contactRedirect = document.querySelector( '.form-wrapper' )
if( contactRedirect && contactRedirect.dataset.redirect ) {
  document.addEventListener( 'wpcf7mailsent', function() {
    document.location.href = contactRedirect.dataset.redirect;
  }, false );
}


// file inputs in cf7 forms
const fileItems = document.querySelectorAll( '.file-item' )
if( fileItems.length > 0 ) {
  for( const fileItem of fileItems ) {
    const input = fileItem.querySelector( 'input' )
    input.value = ''
    input.addEventListener( 'change', e => fileItem.classList.toggle( 'ok', ( input.value !== '' ) ) )
  }
}
